export default "__VITE_ASSET__23f498f4__"